import React from "react";
import "./ApartmentCleaningService.css";

const ApartmentCleaningService = () => {
  return (
    <div className="apartmentcleaning-cleaning-container">
      <h1>Spotless Apartment Living, Simplified</h1>
      <p>
        Perfect for renters and city dwellers, our Apartment Cleaning service is
        designed to maintain cleanliness in smaller spaces with all the care and
        quality of a full-home service.
      </p>
      <h2>What’s Included:</h2>
      <ul>
        <li>Dusting and cleaning of all surfaces</li>
        <li>Bathroom and kitchen sanitation</li>
        <li>Vacuuming and mopping floors</li>
        <li>Trash removal</li>
        <li>Attention to entryways and high-traffic areas</li>
      </ul>
    </div>
  );
};

export default ApartmentCleaningService;
